import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import { LoginComponent } from './login/login.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SettingsConfigurationComponent } from './settings-configuration/settings-configuration.component';
import { RouterModule } from '@angular/router';
import { AuthenticationService } from './services/authentication.service';
import { AuthGuardService } from './services/auth-guard.service';
import { LayoutModule } from '../layouts/layout.module';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '../shared/shared.module';
import {TranslateService, TranslatePipe } from '@ngx-translate/core';
import { PrevilegeAuthorizationModule } from '../authorization/authorization.module';
import { AuthorizationDeniedComponent } from './authorization/authorization-denied/authorization-denied.component';
import { MsalRedirectComponent } from '@azure/msal-angular';

@NgModule({
    imports: [
        CommonModule,
        CoreRoutingModule,
        LayoutModule,
        MatButtonModule,
        MatCheckboxModule,
        SharedModule,
        PrevilegeAuthorizationModule,
        LoginComponent, NotFoundComponent, AuthorizationDeniedComponent, SettingsConfigurationComponent
    ],
    exports: [
        RouterModule,
        MatButtonModule,
        MatCheckboxModule,
        AuthorizationDeniedComponent
    ],
    providers: [
        AuthenticationService,
        AuthGuardService,
        TranslateService,
        TranslatePipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule { }
